import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbUserOutline: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 24, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M12.06,4a2.5,2.5,0,1,1-2.5,2.5A2.49,2.49,0,0,1,12.06,4m0-2a4.5,4.5,0,1,0,4.48,4.5A4.49,4.49,0,0,0,12.06,2Z' />
          <path d='M15.64,14C16.92,14,18,15.56,18,17.4V20H6V17.4C6,15.56,7.08,14,8.36,14h7.28m0-2H8.36C6,12,4,14.42,4,17.4V22H20V17.4c0-3-1.95-5.4-4.36-5.4Z' />
        </g>
      </svg>
    </>
  );
};
